import { render, staticRenderFns } from "./MStoreForm.vue?vue&type=template&id=3634e47c&"
import script from "./MStoreForm.vue?vue&type=script&lang=ts&"
export * from "./MStoreForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports